// 产品解读tab
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import ActionBar from '@/components/SelectSend';
import { useCheckboxGroup } from '@/hooks/useSelectCheck';
import Summary from '@/components/Summary';
import { AnalysisSpec, IncomeEvaluations, SummarySelect } from '../ProductInterpretationTab/index';
import useCopilotValueStore from '@/stores/copilotValueStore';
import { CopilotValue10ProductInfo } from '@/stores/types/copilotValue/copilotValue10';

interface ProductInterpretationRef {
  resetSelectedValues: () => void;
}

const ProductInterpretation = forwardRef<ProductInterpretationRef, {}>((_props, ref) => {
  const { copilotValue10 } = useCopilotValueStore();
  const product_info = copilotValue10.product_info || [];
  const product1Data = product_info[0] || ({} as CopilotValue10ProductInfo);
  const loading = useMemo(() => copilotValue10.loading, [copilotValue10.loading]);
  const totalData = useMemo(() => copilotValue10, [copilotValue10]);

  const {
    selectedValues,
    handleSelectChange,
    handleSelectAll,
    isAllSelected,
    isIndeterminate,
    setSelectedValues
  } = useCheckboxGroup({
    incomeEvaluations: false,
    advantage: false,
    risk: false,
    suggestion: false
  });

  const resetSelectedValues = () => {
    console.log('resetSelectedValues ProductInterpretationTab');
    setSelectedValues({
      incomeEvaluations: false,
      advantage: false,
      risk: false,
      suggestion: false
    });
  };

  useImperativeHandle(ref, () => ({
    resetSelectedValues
  }));

  if (loading) {
    return (
      <div className="min-h-[200px] text-center text-sm text-black">
        Ai已识别客户投顾需求，正在检索市场行情数据生成完整洞察内容，请稍后…
      </div>
    );
  }

  return (
    <>
      <div id="productInterpretation-tab-page">
        {/* 深度解读 */}
        <AnalysisSpec
          fundName={product1Data.产品名称}
          fundCode={product1Data.产品代码 || product1Data.基金代码}
          fundInfo={product1Data}
        />
        {/* ai总结 */}
        <Summary isShowSuggestions={false} title="AI总结" content={totalData.一句话解读} />
        {/* 收益与回撤概览 */}
        <IncomeEvaluations
          selected={selectedValues.incomeEvaluations}
          totalData={totalData}
          selectChange={handleSelectChange}
        />
        <div className="grid gap-3 pb-[56px]">
          {/* 产品优势 */}
          <SummarySelect
            type="advantage"
            selected={selectedValues.advantage}
            selectChange={handleSelectChange}
            content=""
          >
            <div className="text-left text-xs leading-relaxed text-gray-900">
              <ul className="list-inside list-disc text-sm">
                {(totalData.产品优势 || '')
                  .split(/\d+\.\s+/)
                  .filter(item => item.trim())
                  .map((item: string, index: number) => (
                    <li key={index}>{item.trim()}</li>
                  ))}
              </ul>
            </div>
          </SummarySelect>

          {/* 风险提示 */}
          <SummarySelect
            type="risk"
            content=""
            selected={selectedValues.risk}
            selectChange={handleSelectChange}
          >
            <div className="text-left text-xs leading-relaxed text-gray-900">
              <ul className="list-inside list-disc text-sm">
                {(totalData.风险提示 || '')
                  .split(/\d+\.\s+/)
                  .filter(item => item.trim())
                  .map((item: string, index: number) => (
                    <li key={index}>{item.trim()}</li>
                  ))}
              </ul>
            </div>
          </SummarySelect>

          {/* 操作建议 */}
          <SummarySelect
            type="suggestion"
            selected={selectedValues.suggestion}
            selectChange={handleSelectChange}
            content=""
          >
            <div className="text-left text-xs leading-relaxed text-gray-900">
              <ul className="list-inside list-disc text-sm">
                {(totalData.操作建议 || []).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </SummarySelect>
        </div>
      </div>
      {/* 操作栏 */}
      <ActionBar
        selectAll={isAllSelected}
        isIndeterminate={isIndeterminate}
        onUpdateSelectAll={handleSelectAll}
        selectedMetrics={selectedValues}
        isFixed={true}
        tabType="productInterpretation"
      />
    </>
  );
});

ProductInterpretation.displayName = 'ProductInterpretation';

export default ProductInterpretation;
